import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Servizi from "./components/Servizi";
import PercheNoi from "./components/PercheNoi";
import Catalogo from "./components/Catalogo";
import ChiSiamo from "./components/ChiSiamo";
import Contatti from "./components/Contatti";
import Footer from "./components/Footer";
import AdminApp from "./admin/AdminApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-8">
                    <p className="font-display text-xl font-bold">
                        Qualcosa è andato storto. Ricarica la pagina.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function Landing() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain min-h-screen bg-background text-foreground overflow-x-clip">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Servizi />
                <PercheNoi />
                <Catalogo />
                <ChiSiamo />
                <Contatti />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <ErrorBoundary>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<AdminApp />} />
                </Routes>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

export default App;